// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import useMergeProps from "@toolkit/Framework/Common/Hooks/useMergeProps";
import overrideProps from "@toolkit/Framework/Common/Utilities/overrideProps";
import { stretchStyles } from "@toolkit/Themes/common/mixins";
import React, { FC } from "react";
import { css } from "styled-components";

export interface StretchLayoutProps {
    id: string;
    overridedStyles?: StretchLayoutStyles;
    extendedStyles?: StretchLayoutStyles;
}

export interface StretchLayoutStyles {
    wrapper?: InjectableCss;
}

export const stretchLayoutStyles: StretchLayoutStyles = {
    wrapper: {
        css: css`
            ${stretchStyles(true)}
            width: 100%;
        `,
    },
};

const StretchLayout: FC<StretchLayoutProps> = ({ id, children, overridedStyles, extendedStyles }) => {
    const styles = useMergeProps(overrideProps(stretchLayoutStyles, overridedStyles), extendedStyles);
    const content = children || <Zone contentId={id} zoneName="Content" />;

    return (
        <>
            <Zone contentId={id} zoneName="Top" />
            <StyledWrapper {...styles.wrapper}>{content}</StyledWrapper>
            <Zone contentId={id} zoneName="Bottom" />
        </>
    );
};

export default StretchLayout;
